localStorage.setItem('CurrentPageName', 'index');
window.location.replace('/reservation_map.html');
